import Header from './components/Header';
import Hero from './components/Hero';
import AppSection from './components/AppSection';
import MediaSection from './components/MediaSection';
import ContactSection from './components/ContactSection';
import FAQSection from './components/FAQSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <AppSection />
        <MediaSection />
        <ContactSection />
        <FAQSection />
        <TopicsSection />
        <FeaturesSection />
        <IndexSection />
        <RankingSection />
        <UpdatesSection />
        <AboutSection />
        <CarouselSection />
        <CommentsSection />
        <CardsSection />
      </main>
      <Footer />
    </>
  );
}